module.exports = {"es-PY":{"map":{"cooperatives_list":"Lista de asociaciones"}}}